<template lang="pug">
  span.ui-file-preview
    img(v-if="preview && $file.isImage()" :src="$file.getImageUrl()")
    b-icon(v-else :icon="$file.getIconName()" :type="$file.getIconType()" :size="size")
</template>

<script>
import FileHelper from '@/helpers/file';

export default {
  name: 'ui-file-preview',
  props: {
    file: [Object, File],
    size: String,
    preview: Boolean,
  },
  computed: {
    $file() {
      return new FileHelper(this.file);
    },
  },
};
</script>
